import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-kiosk-label-navbar',
	templateUrl: './kiosk-label-navbar.component.html',
	styleUrls: ['./kiosk-label-navbar.component.scss'],
})
export class KioskLabelNavbarComponent {
	@Input() startOverButtonText = 'start over';
	@Input() exitKioskButtonText = 'exit kiosk';
	@Input() locationText: string;
	@Output() startOverButtonEmitter = new EventEmitter();
	@Output() exitKioskButtonEmitter = new EventEmitter();

	faChevronLeft = faChevronLeft;
	isProduction = environment.production;

	// biome-ignore lint/complexity/noUselessConstructor: <explanation>
	constructor() {}

	get isWeb() {
		return StorageService.isWeb;
	}

	startOver() {
		this.startOverButtonEmitter.emit();
	}

	exit() {
		this.exitKioskButtonEmitter.emit();
	}
}
